import script from "./WhoTrainList.vue?vue&type=script&setup=true&lang=js"
export * from "./WhoTrainList.vue?vue&type=script&setup=true&lang=js"

import "./WhoTrainList.vue?vue&type=style&index=0&id=910974c4&lang=scss"

const __exports__ = script;

export default __exports__